/** 各个模块需要在登录后立即执行的操作。
 * 产品库：需要请求当前项目信息；
 * 材料库：暂无；
 * 模块库：暂无；
 * **/
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      platform: 'platform',
      user: 'user/user',
      userToken: 'user/userToken',
    }),
    // 当前页面属于什么模块
    routeModule() {
      return this.$route.meta ? this.$route.meta.module : ''
    },
  },
  methods: {
    ...mapActions({
      loadCurrentProject: 'selectionList/loadCurrentProject',
    }),
    afterLoginFn() {
      return new Promise((resolve) => {
        const loginDone = this.platform === 'web' ? !!this.user.strId : !!this.userToken
        if (loginDone) {
          if (this.routeModule === 'product') {
            this.loadCurrentProject().finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        } else {
          resolve()
        }
      })
    }
  }
}
